<template>
    <div class="wrapper">
        <!-- <notifications></notifications> -->
        <side-bar>
            <template v-slot:links>
                <sidebar-item
                    :link="{name: 'Dashboard', icon: 'fad fa-tachometer-alt-fastest text-warning', path: '/dashboard'}"/>
                <sidebar-item
                    v-if="currentUser && (currentUser.roles.indexOf('topdesk_admin') !== -1 || currentUser.roles.indexOf('topdesk_user') !== -1) && currentUser.topdesk_user"
                    :link="{name: 'Servicedesk', icon: 'fad fa-tasks text-success', path: '/incidents'}">
                    <sidebar-item
                        v-if="currentUser && (currentUser.roles.indexOf('topdesk_admin') !== -1 || currentUser.roles.indexOf('topdesk_user') !== -1) && currentUser.topdesk_user"
                        :link="{name: 'Fälle', icon: 'fad fa-tasks text-success', path: '/incidents'}"/>
                    <sidebar-item
                        v-if="currentUser && (currentUser.roles.indexOf('topdesk_admin') !== -1 || currentUser.roles.indexOf('topdesk_user') !== -1) && currentUser.topdesk_user"
                        :link="{name: 'Assets', icon: 'fad fa-tasks text-success', path: '/assets'}"/>
                    <sidebar-item
                        v-if="currentUser && (currentUser.roles.indexOf('topdesk_admin') !== -1 || currentUser.roles.indexOf('topdesk_user') !== -1) && currentUser.topdesk_user"
                        :link="{name: 'Statistik', icon: 'fad fa-tasks text-success', path: '/stats'}"/>
                </sidebar-item>
                <sidebar-item
                    v-if="currentUser && currentUser.clientId && currentUser.roles.indexOf('abacus_user') !== -1"
                    :link="{name: 'CRM', icon: 'fad fa-balance-scale text-danger', path: '/contracts' }">
                    <sidebar-item
                        v-if="currentUser && currentUser.clientId && currentUser.roles.indexOf('abacus_user') !== -1"
                        :link="{name: 'Verträge', icon: 'fad fa-balance-scale text-yellow', path: '/contracts'}"/>
                    <sidebar-item
                        v-if="currentUser && currentUser.clientId && currentUser.roles.indexOf('abacus_user') !== -1"
                        :link="{name: 'Leistungen', icon: 'fad fa-balance-scale text-green', path: '/services'}"/>
                    <sidebar-item
                        v-if="currentUser && currentUser.clientId && currentUser.roles.indexOf('abacus_user') !== -1"
                        :link="{name: 'Rechnungen', icon: 'fad fa-balance-scale text-danger', path: '/invoices'}"/>
                </sidebar-item>
                <sidebar-item
                    v-if="currentUser && currentUser.clientId && currentUser.roles.indexOf('rio_user') !== -1 && client.client_rio === 1"
                    :link="{name: 'RIONet', icon: 'fad fa-server text-info', path: '/rionews/'}">
                    <sidebar-item
                        v-if="currentUser && currentUser.clientId && currentUser.roles.indexOf('rio_user') !== -1"
                        :link="{name: 'Meldungen', icon: 'fad fa-server text-danger', path: '/rionews/'}"/>
                    <sidebar-item
                        v-if="currentUser && currentUser.clientId && currentUser.roles.indexOf('rio_user') !== -1"
                        :link="{name: 'Formulare', icon: 'fad fa-server text-danger', path: '/forms'}"/>
                    <!--                    <sidebar-item
                                            v-if="currentUser && currentUser.clientId && currentUser.roles.indexOf('rio_user') !== -1"
                                            :link="{name: 'Gruppen', icon: 'fad fa-server text-danger', path: '/groups'}"/>-->
                </sidebar-item>
                <sidebar-item
                    v-if="currentUser"
                    :link="{name: 'Lizenz-Services', icon: 'fad fa-list-timeline text-dark', path: '/licenses'}"/>
                <sidebar-item
                    v-if="currentUser"
                    :link="{name: 'Talus Mitarbeiter', icon: 'fad fa-user-astronaut text-warning', path: '/employees'}"/>
                <sidebar-item
                    v-if="currentUser && currentUser.roles.indexOf('user_admin') !== -1"
                    :link="{name: 'Talus Kunden', icon: 'fad fa-user-shield text-primary', path: '/customers'}"/>
                <sidebar-item
                    v-if="currentUser && (currentUser.roles.indexOf('client_admin') !== -1 || currentUser.roles.indexOf('user_admin') !== -1)"
                    :link="{name: 'Benutzer', icon: 'fad fa-users-cog text-green', path: '/users'}"/>
                <sidebar-item
                    v-if="currentUser"
                    :link="{name: 'Downloads', icon: 'fad fa-folder-arrow-down text-indigo', path: '/downloads'}"/>
                <!--                <sidebar-item
                                    v-if="currentUser && currentUser.roles.indexOf('user_admin') !== -1"
                                    :link="{name: 'Templates', icon: 'fad fa-file-code text-warning', path: '/templates'}"/>-->
                <sidebar-item
                    v-if="currentUser && currentUser.clientId && currentUser.roles.indexOf('abacus_user') !== -1"
                    :link="{name: 'Profil', icon: 'fad fa-address-book text-yellow', path: '/contacts'}"/>

                <div class="dropdown-divider"></div>
                <li class="nav-item">
                    <a v-if="!currentUser" class="nav-link" href @click.prevent="logIn">
                        <i class="ni ni-key-25 text-primary"></i>
                        <span class="nav-link-text">Login</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a v-if="currentUser" class="nav-link" href @click.prevent="logOut">
                        <i class="fad fa-sign-out text-gray"></i>
                        <span class="nav-link-text">Logout</span>
                    </a>
                </li>
            </template>

            <!--            <template v-slot:links-after>
                            <hr class="my-3"/>
                            <h6 class="navbar-heading p-0 text-muted">Dokumentation</h6>

                            <ul class="navbar-nav mb-md-3">
                                <li class="nav-item">
                                    <a
                                        class="nav-link"
                                        href="https://demos.creative-tim.com/vue-argon-dashboard-pro/documentation"
                                        target="_blank"
                                    >
                                        <i class="ni ni-spaceship"></i>
                                        <span class="nav-link-text">Getting started</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a
                                        class="nav-link"
                                        href="https://demos.creative-tim.com/vue-argon-dashboard-pro/documentation/foundation/colors.html"
                                        target="_blank"
                                    >
                                        <i class="ni ni-palette"></i>
                                        <span class="nav-link-text">Foundation</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a
                                        class="nav-link"
                                        href="https://demos.creative-tim.com/vue-argon-dashboard-pro/documentation/components/avatars.html"
                                        target="_blank"
                                    >
                                        <i class="ni ni-ui-04"></i>
                                        <span class="nav-link-text">Components</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a
                                        class="nav-link"
                                        href="https://demos.creative-tim.com/vue-argon-dashboard-pro/documentation/components/plugin_datepicker.html"
                                        target="_blank"
                                    >
                                        <i class="fad fa-chart-pie"></i>
                                        <span class="nav-link-text">Plugins</span>
                                    </a>
                                </li>
                            </ul>
                        </template>-->
        </side-bar>
        <div class="main-content">
            <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

            <div @click="$sidebar.displaySidebar(false)">
                <router-view></router-view>
            </div>
            <content-footer v-if="!$route.meta.hideFooter"></content-footer>
        </div>
    </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
    if (hasElement(className)) {
        new PerfectScrollbar(`.${className}`);
    } else {
        // try to init it later in case this component is loaded async
        setTimeout(() => {
            initScrollbar(className);
        }, 100);
    }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import UserService from '@/services/user.service';

export default {
    components: {
        DashboardNavbar,
        ContentFooter,
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
    },
    data() {
        return {
            client: {},
            error: '',
        };
    },
    methods: {
        getClient() {
            if(this.currentUser && this.currentUser.clientId) {
                UserService.getCustomer(this.currentUser.clientId).then(
                    response => {
                        this.client = response.data;
                    },
                    error => {
                        this.getError(error);
                    }
                );
            }
        },
        getError(error) {
            if (error.response && error.response.status === '401') {
                this.error = 'you are not logged in!';
            } else if (error.response && error.response.status === '403') {
                this.error = 'you are not permitted!';
            } else {
                this.error =
                    (error.response && error.response.data) ||
                    error.message ||
                    error.toString();
            }
        },
        initScrollbar() {
            let isWindows = navigator.platform.startsWith("Win");
            if (isWindows) {
                initScrollbar("sidenav");
            }
        },
        logIn() {
            this.$store.dispatch('auth/login');
        },
        logOut() {
            this.$store.dispatch('auth/logout');
            this.$router.push('/');
        },
    },
    created(){
        this.getClient();
    },
    mounted() {
        this.initScrollbar();
    },
};
</script>
<style lang="scss"></style>
